import * as React from 'react';

import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemFooter,
  ItemGroup,
  ItemHeader,
  ItemMedia,
  ItemSeparator,
  ItemTitle,
} from './components/ui/item.js';

const DimeItemGroupContext = React.createContext(false);

export function DimeItemGroup({ ...props }: Readonly<React.ComponentProps<typeof ItemGroup>>) {
  return (
    <DimeItemGroupContext.Provider value={true}>
      <ItemGroup {...props} />
    </DimeItemGroupContext.Provider>
  );
}

export function DimeItemSeparator({
  ...props
}: Readonly<React.ComponentProps<typeof ItemSeparator>>) {
  return <ItemSeparator {...props} />;
}

export function DimeItem({
  ...props
}: Readonly<React.ComponentProps<typeof Item> & { role?: React.AriaRole }>) {
  const inGroup = React.useContext(DimeItemGroupContext);
  // WHY: with asChild the role would land on the child, and a listitem role on an <a> erases it as a link.
  if (inGroup && props.asChild) {
    return (
      <div role="listitem">
        <Item {...props} />
      </div>
    );
  }
  return <Item role={inGroup ? 'listitem' : undefined} {...props} />;
}

export function DimeItemMedia({ ...props }: Readonly<React.ComponentProps<typeof ItemMedia>>) {
  return <ItemMedia {...props} />;
}

export function DimeItemContent({ ...props }: Readonly<React.ComponentProps<typeof ItemContent>>) {
  return <ItemContent {...props} />;
}

export function DimeItemTitle({ ...props }: Readonly<React.ComponentProps<typeof ItemTitle>>) {
  return <ItemTitle {...props} />;
}

export function DimeItemDescription({
  ...props
}: Readonly<React.ComponentProps<typeof ItemDescription>>) {
  return <ItemDescription {...props} />;
}

export function DimeItemActions({ ...props }: Readonly<React.ComponentProps<typeof ItemActions>>) {
  return <ItemActions {...props} />;
}

export function DimeItemHeader({ ...props }: Readonly<React.ComponentProps<typeof ItemHeader>>) {
  return <ItemHeader {...props} />;
}

export function DimeItemFooter({ ...props }: Readonly<React.ComponentProps<typeof ItemFooter>>) {
  return <ItemFooter {...props} />;
}
